/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is the transfer exact?`)
};

const es_hplc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es exacta la transferencia?`)
};

const de_hplc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist der Transfer exakt?`)
};

const nl_hplc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is de transfer exact?`)
};

const fr_hplc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le transfert est-il exact ?`)
};

const it_hplc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il trasferimento è esatto?`)
};

const pt_br2_hplc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A transferência é exata?`)
};

const pt_hplc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A transferência é exata?`)
};

const ja_hplc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この移行は正確ですか?`)
};

const zh_hplc_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转移结果是否精确？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_faq_q4", locale)
	if (locale === "en") return en_hplc_faq_q4(inputs)
	if (locale === "es") return es_hplc_faq_q4(inputs)
	if (locale === "de") return de_hplc_faq_q4(inputs)
	if (locale === "nl") return nl_hplc_faq_q4(inputs)
	if (locale === "fr") return fr_hplc_faq_q4(inputs)
	if (locale === "it") return it_hplc_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_faq_q4(inputs)
	if (locale === "pt") return pt_hplc_faq_q4(inputs)
	if (locale === "ja") return ja_hplc_faq_q4(inputs)
	return zh_hplc_faq_q4(inputs)
};